import { UsersThree, Kanban, ChartLineUp } from "@phosphor-icons/react";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";
import InquiryForm from "../components/InquiryForm";
import { Reveal } from "../components/Reveal";
import { usePageMeta } from "../hooks/usePageMeta";

const BENEFITS = [
    { icon: UsersThree, title: "Qualified International Patients", text: "Connect with patients actively seeking healthcare solutions." },
    { icon: Kanban, title: "Streamlined Case Coordination", text: "Organize patient information, medical documents, consultations and treatment workflows." },
    { icon: ChartLineUp, title: "International Patient Intelligence", text: "Gain insights into markets, specialties, patient journeys and operational performance." },
];

export default function PartnerPage() {
    usePageMeta(
        "International Patient Hospital Partnerships | GoMedVoyage",
        "Become a GoMedVoyage partner — connect your hospital with qualified international patients through a connected digital journey."
    );

    return (
        <div data-testid="partner-page">
            <Header />
            <main>
                <section className="pt-40 pb-24 bg-brand-blue noise-overlay relative overflow-hidden">
                    <div className="absolute -top-40 -right-40 w-[480px] h-[480px] rounded-full bg-brand-green/10 blur-3xl" aria-hidden="true" />
                    <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
                        <Reveal>
                            <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand-green-light">Partner With GoMedVoyage</p>
                        </Reveal>
                        <Reveal delay={0.1}>
                            <h1 data-testid="partner-headline" className="mt-6 max-w-4xl font-heading text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter leading-[1.05] text-white">
                                Turn international patient demand into a <span className="text-brand-green-light">connected digital journey.</span>
                            </h1>
                        </Reveal>
                        <Reveal delay={0.2}>
                            <p className="mt-6 max-w-2xl text-base md:text-lg leading-relaxed text-white/70">
                                Join the healthcare provider network we are building — and help shape the infrastructure
                                for cross-border healthcare.
                            </p>
                        </Reveal>
                    </div>
                </section>

                <section className="py-24 bg-white">
                    <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-16">
                        <div className="lg:col-span-5 space-y-5">
                            {BENEFITS.map((b, i) => (
                                <Reveal key={b.title} delay={0.08 * i}>
                                    <div data-testid={`partner-benefit-${i + 1}`} className="rounded-3xl border border-slate-100 bg-white p-8 shadow-[0_8px_30px_rgb(0,0,0,0.04)]">
                                        <b.icon size={30} weight="duotone" className="text-brand-green" />
                                        <h3 className="mt-4 font-heading text-lg font-semibold text-brand-blue">{b.title}</h3>
                                        <p className="mt-2 text-sm leading-relaxed text-slate-600">{b.text}</p>
                                    </div>
                                </Reveal>
                            ))}
                        </div>
                        <div className="lg:col-span-7">
                            <Reveal delay={0.15}>
                                <div className="rounded-3xl border border-slate-100 bg-white p-8 sm:p-10 shadow-[0_16px_48px_rgb(10,37,64,0.08)]">
                                    <h2 className="font-heading text-2xl font-semibold text-brand-blue">Become a partner</h2>
                                    <p className="mt-2 mb-8 text-sm text-slate-600">Tell us about your organization and we'll reach out.</p>
                                    <InquiryForm defaultInterest="Hospital Partnership" testidPrefix="partner" />
                                </div>
                            </Reveal>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    );
}
